import React, { PureComponent } from "react";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import KBELogo from "../account/img/kbe-Logo-66454.png";
import Logout from "../account/log_out/LogOut";
import VerticalSpace from "./components/VerticalSpace";
import AppConfig from "../../config/appconfig.json";
import moment from "moment";
import { Route } from "react-router-dom";

export default class Services extends PureComponent {
  constructor(props) {
    super(props);

    const username = localStorage.getItem("usernameLogin");
    this.state = {
      username: username ? username : "",
      systemList: []
    };
  }

  componentDidMount() {
    const kbeSid = localStorage.getItem("kbeSid");
    if (kbeSid) {
      let isretrieveCustomerSystemFailed = false;
      // Call Back-End Services
      fetch(
        `${AppConfig.BACK_END_URL}/APIClient/RetrieveCustomerSystem?Sid=` +
        kbeSid
      )
        .then(response => {
          // console.log(response);
          if (response.ok === false) {
            isretrieveCustomerSystemFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isretrieveCustomerSystemFailed) {
            const custSys = localStorage.getItem("RetrieveCustomerSystem");
            if (custSys) {
              const respObj = JSON.parse(custSys);
              this.setState({ systemList: respObj });
            }
          } else {
            const respObj = JSON.parse(json);
            // console.log(respObj);
            this.setState({
              systemList: respObj
            });
          }
        })
        .catch(() => {
          console.log(
            "Something went wrong when retrieving customer systems. Please try again."
          );
          const custSys = localStorage.getItem("RetrieveCustomerSystem");
          if (custSys) {
            const respObj = JSON.parse(custSys);
            this.setState({ systemList: respObj });
          }
        });
    }
  }

  handleBookAppt() {
    window.location = "/register_appt";
  }

  render() {
    return (
      <div>
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <div className="account__head">
                <img src={KBELogo} alt="logo" />
              </div>
              <div className="account__main">
                <div>Welcome {this.state.username}</div>
                <div>
                  <Logout />
                </div>
                <List component="nav">
                  <Divider />
                  {this.state.systemList.map(sys =>
                    <div key={sys.Sid}>
                      <Route
                        render={({ history }) => (
                          <ListItem onClick={() => {
                            history.push({
                              pathname: "/svc_records"
                              , state: { systemId: sys.Sid, system: sys }
                            });
                            //console.log('click');
                          }} button>
                            <Grid container spacing={0}>
                              <Grid item xs={6}>
                                <ListItemText>
                                  <div className="list-text">{sys.Brand + " " + sys.Type + " " + sys.Model}</div>
                                  {moment(sys.ServicingDue, "DD MMM YYYY") <= moment() ? (
                                    <div className="list-text list-text-red">Next Servicing Due: {sys.ServicingDue}</div>
                                  ) : (
                                      <div className="list-text">Next Servicing Due:{" "}&nbsp;&nbsp;<br />{sys.ServicingDue}</div>
                                    )}
                                </ListItemText>
                              </Grid>
                              <Grid item xs={6}>
                                <ListItemText>
                                  <div className="list-text">
                                    {sys.Street + " " + sys.Block + " " + sys.Unit}</div>
                                  <div className="list-text">Singapore {sys.PostalCode}</div>
                                </ListItemText>
                              </Grid>
                            </Grid>
                          </ListItem>
                        )}
                      />
                      <Divider />
                    </div>
                  )}
                  {/* <ListItem onClick={this.handleBookAppt} button>
                    <Grid container spacing={0}>
                      <Grid item xs={6}>
                        <ListItemText>
                          <div className="list-text">Samsung System 2</div>
                          <div className="list-text list-text-red">
                            Next Servicing Due: 31-Jul-18
                          </div>
                        </ListItemText>
                      </Grid>
                      <Grid item xs={6}>
                        <ListItemText>
                          <div className="list-text">
                            BLK 1A Tanglin Road #10-2212
                          </div>
                          <div className="list-text">Singapore 882001</div>
                        </ListItemText>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <Grid container spacing={0}>
                      <Grid item xs={6}>
                        <ListItemText>
                          <div className="list-text">LG ARTCOOL</div>
                          <div className="list-text">
                            Next Servicing Due: 1-Feb-19
                          </div>
                        </ListItemText>
                      </Grid>
                      <Grid item xs={6}>
                        <ListItemText>
                          <div className="list-text">2C Bukit Timah Road</div>
                          <div className="list-text">Singapore 555113</div>
                        </ListItemText>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <Grid container spacing={0}>
                      <Grid item xs={6}>
                        <ListItemText>
                          <div className="list-text">Daikin System 4</div>
                          <div className="list-text">
                            Next Servicing Due: 22-Dec-18
                          </div>
                        </ListItemText>
                      </Grid>
                      <Grid item xs={6}>
                        <ListItemText>
                          <div className="list-text">
                            BLK 666 Yishun Ring Road
                          </div>
                          <div className="list-text">Singapore 760666</div>
                        </ListItemText>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider /> */}
                </List>
                <VerticalSpace />
              </div>
              <SimpleBottomNavigation value={2} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/Services.js